import script from "./ContractManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractManagement.vue?vue&type=script&setup=true&lang=js"

import "./ContractManagement.vue?vue&type=style&index=0&id=b363c298&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b363c298"]])

export default __exports__